module.exports = __webpack_public_path__ + "img/index_mobile_middle_pic_5.0901f931.png";